/**
 * @generated SignedSource<<6eaf8c938af119308912503e095cf581>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionRulesPageQuery$variables = {
  slug: string;
};
export type CompetitionRulesPageQuery$data = {
  readonly competitionBySlug: {
    readonly id: string;
    readonly latestRule: {
      readonly id: string;
      readonly text: string;
    };
    readonly title: string;
    readonly viewerCanAccept: boolean;
    readonly viewerCanUpdate: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionAcceptRulesButtonCompetitionFragment">;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  };
};
export type CompetitionRulesPageQuery = {
  response: CompetitionRulesPageQuery$data;
  variables: CompetitionRulesPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMPETITION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMPETITION\")"
},
v6 = {
  "alias": "viewerCanAccept",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMPETITION_RULE_AGREEMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMPETITION_RULE_AGREEMENT\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionRulesPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionAcceptRulesButtonCompetitionFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CompetitionRulesPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe424959988245c0fd199afd6b637a38",
    "id": null,
    "metadata": {},
    "name": "CompetitionRulesPageQuery",
    "operationKind": "query",
    "text": "query CompetitionRulesPageQuery(\n  $slug: String!\n) {\n  viewer @ifAllowed {\n    __typename\n    id\n  }\n  competitionBySlug(slug: $slug) {\n    id\n    title\n    latestRule {\n      id\n      text\n    }\n    viewerCanUpdate: viewerCan(action: UPDATE_COMPETITION)\n    viewerCanAccept: viewerCan(action: CREATE_COMPETITION_RULE_AGREEMENT)\n    ...CompetitionAcceptRulesButtonCompetitionFragment\n  }\n}\n\nfragment CompetitionAcceptRulesButtonCompetitionFragment on Competition {\n  id\n  latestRule {\n    id\n    entityAgreement @ifAllowed {\n      id\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "156f693771869536c73aef585838ea70";

export default node;
